/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-explicit-any */
import "./Modal.css";

import { Button1, Button2, Selectbutton } from "../../Buttons";

import { IoIosClose } from "react-icons/io";
import { GoUnlock } from "react-icons/go";
import { RxLightningBolt } from "react-icons/rx";
import { IoMdInformationCircleOutline } from "react-icons/io";
import { IoMdArrowForward } from "react-icons/io";
import Confetti from "react-confetti";
import { useRef, useEffect, useState } from "react";
import { useStaticData } from "../../../Providers/Data";
import { MdCheckBoxOutlineBlank, MdOutlineCheckBox } from "react-icons/md";

export const Modal1 = ({ onClose, credits, coins, onBuy, OnClick }) => {
  return (
    <div className="w-screen h-screen flex flex-col items-center justify-center  fixed top-0 left-0 right-0 bottom-0 z-[899] font-inter filter backdrop-blur-[1px]">
      <div className="bg-[#FAFAFA] p-6 flex flex-col items-center gap-4 rounded-lg w-[480px]">
        <div
          onClick={() => onClose()}
          className="w-full flex justify-end cursor-pointer"
        >
          <IoIosClose color="black" size={24} />
        </div>
        <div className="font-[inter] text-[20px] font-[700] text-[#424242]">
          Unlocking Influencer{" "}
        </div>
        <div className="font-[inter] text-[12px] font-[400] text-[#757575]">
          You are only one step away to unlock a influncer
        </div>
        <div className="font-[inter] text-[12px] font-[400] text-[#059669] mt-[20px]">
          Credits Available : <b>{credits}</b>
        </div>
        <div className="font-[inter] text-[12px] font-[400] text-[#757575]">
          Credits required for Unlock : <b>{coins}</b>
        </div>
        {parseInt(credits) >= parseInt(coins) ? (
          <div className="mt-[20px]">
            <Button1
              icon={<GoUnlock size={16} />}
              text="Unlock Now"
              onClick={() => onBuy()}
              rightIcon={undefined}
              background={undefined}
              textColor={undefined}
              borderColor={undefined}
            />
          </div>
        ) : (
          <>
            <div className="flex items-center gap-[8px] font-[inter] text-[12px] font-[400] text-[#AD0000] mt-[20px]">
              Insufficient Credits <IoMdInformationCircleOutline />
            </div>
            <Button2
              onClick={() => OnClick()}
              icon={<RxLightningBolt size={16} />}
              text="Recharge Credits"
              rightIcon={undefined}
              background={undefined}
              textColor={undefined}
              borderColor={undefined}
            />
          </>
        )}
      </div>
    </div>
  );
};

export const Modal2 = ({ onClick, onClose, name, profile }) => {
  const [, setShowConfetti] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowConfetti(true);
    }, 1000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="w-screen h-screen flex flex-col items-center justify-center  fixed top-0 left-0 right-0 bottom-0 z-[899] font-inter filter backdrop-blur-[1px]">
      <Confetti
        width={window.innerWidth}
        height={window.innerHeight}
        numberOfPieces={200} // Adjust the number of confetti pieces
        gravity={0.1} // Adjust the gravity for confetti falling speed
        initialVelocityX={{ min: -5, max: 5 }} // Adjust initial horizontal velocity
        initialVelocityY={{ min: 10, max: 20 }} // Adjust initial vertical velocity
        colors={["#FFD700", "#FFA500", "#FF6347", "#FF4500"]} // Use colors resembling fireworks
        recycle={false}
      />

      <div className="bg-[#FAFAFA] p-6 flex flex-col items-center gap-4 rounded-lg w-[480px]">
        <div
          onClick={() => onClose()}
          className="w-full flex justify-end cursor-pointer"
        >
          <IoIosClose color="black" size={24} />
        </div>
        <img
          src="https://anchors-collab.s3.ap-south-1.amazonaws.com/assets/SuccessBuy.svg"
          alt=""
        />
        <div className="font-[inter] text-[20px] font-[700] text-[#10B981]">
          Congratulations!
        </div>
        <div className="font-[inter] text-[12px] font-[400] text-[#757575]">
          You have successfully Unlocked Influencer
        </div>
        <img
          className="size-[80px] border-[#FBBF24] border-[1px] rounded"
          src={profile}
          onError={(e: any) => {
            e.target.onerror = null;
            e.target.src =
              "https://anchors-collab.s3.ap-south-1.amazonaws.com/assets/user.png";
          }}
          alt=""
        />
        <div className="font-[inter] text-[16px] font-[600] text-[#424242]">
          {name}
        </div>

        <div className="mt-[20px]">
          <Button1
            rightIcon={<IoMdArrowForward size={16} />}
            text="Check Profile"
            onClick={() => onClick()}
            icon={undefined}
            background={undefined}
            textColor={undefined}
            borderColor={undefined}
          />
        </div>
      </div>
    </div>
  );
};

export const FilterOptionModal = ({
  list,
  onClose,
  setfilters,
  filters,
  position,
  masterItemName,
}) => {
  const modalRef = useRef(null);

  // Add an event listener to handle clicks outside the modal
  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        onClose(); // Call the onClose function if clicked outside the modal
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);

    // Cleanup the event listener on component unmount
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [onClose]);

  const toggleFilter = (item) => {
    if (filters.includes(item)) {
      setfilters((prev) => prev.filter((filter) => filter !== item));
    } else {
      setfilters((prev) => [...prev, item]);
    }
  };

  return (
    <div
      style={{ left: `${(100 / 6) * position}%` }}
      className="FilterOptionModal"
      ref={modalRef}
    >
      <div className="filter-options">
        {list?.map((item) => (
          <Selectbutton
            key={item}
            OnClick={() => toggleFilter(masterItemName ? item?._id : item)}
            text={masterItemName ? item?.[masterItemName] : item}
            value={masterItemName ? item?._id : item}
            item={
              filters?.includes(masterItemName ? item?._id : item)
                ? masterItemName
                  ? item?._id
                  : item
                : ""
            }
          />
        ))}
      </div>
    </div>
  );
};

export const SideModal = ({
  OnClose,
  OnClick,
  selectedMonetizationFilters,
  setSelectedMonetizationFilters,
  selectedPaidAudienceFilters,
  setSelectedPaidAudienceFilters,
  selectedCollaboratedWithFilters,
  setSelectedCollaboratedWithFilters,
  selectedCampaignGoalsFilters,
  setSelectedCampaignGoalsFilters,
  selectedLocationFilters,
  setSelectedLocationFilters,
  selectedCrossPlatformFilters,
  setSelectedCrossPlatformFilters,
}) => {
  const [AdvanceFilterOptionModal, OpenAdvanceFilterOptionsModal] =
    useState(false);
  const [SelectedAdvanceFilter, SetSelectedAdvanceFilter] = useState("");
  const [selectedFilterState, setSelectedFilterState] = useState([]);
  const [masterItemName, setMasterItemName] = useState(null);
  const staticData = useStaticData();

  const [AdvanceFilters, SetAdvanceFilters] = useState({
    "Monetisation Platforms": [],
    "Total Paid Audience": [
      "1-10",
      "11-50",
      "51-100",
      "101-200",
      "201-500",
      "501-1000",
      "More than 1000",
    ],
    "Collaborated With": [],
    "Campaign Goal": [],
    Location: [],
    "Cross-platform Presence": [],
  });

  useEffect(() => {
    staticData?.getNewDataFromType("Platform Name").then((e) => {
      SetAdvanceFilters((prev) => {
        return { ...prev, "Monetisation Platforms": e };
      });
    });
    staticData?.getNewDataFromType("Goal / KPI").then((e) => {
      SetAdvanceFilters((prev) => {
        return { ...prev, "Campaign Goal": e };
      });
    });
    staticData?.getNewDataFromType("Audience Platform").then((e) => {
      SetAdvanceFilters((prev) => {
        return { ...prev, "Cross-platform Presence": e };
      });
    });
    staticData?.getCollabWith().then((e) => {
      SetAdvanceFilters((prev) => {
        return { ...prev, "Collaborated With": e };
      });
    });
  }, []);

  const toggleFilter = (item, filters, setfilters) => {
    if (filters.includes(item)) {
      setfilters((prev) => prev.filter((filter) => filter !== item));
    } else {
      setfilters((prev) => [...prev, item]);
    }
  };

  const handleSelectfilter = (value) => {
    if (SelectedAdvanceFilter === "Monetisation Platforms") {
      toggleFilter(
        value,
        selectedMonetizationFilters,
        setSelectedMonetizationFilters
      );
    }
    if (SelectedAdvanceFilter === "Total Paid Audience") {
      toggleFilter(
        value,
        selectedPaidAudienceFilters,
        setSelectedPaidAudienceFilters
      );
    }
    if (SelectedAdvanceFilter === "Collaborated With") {
      toggleFilter(
        value,
        selectedCollaboratedWithFilters,
        setSelectedCollaboratedWithFilters
      );
    }
    if (SelectedAdvanceFilter === "Campaign Goal") {
      toggleFilter(
        value,
        selectedCampaignGoalsFilters,
        setSelectedCampaignGoalsFilters
      );
    }
    if (SelectedAdvanceFilter === "Location") {
      toggleFilter(value, selectedLocationFilters, setSelectedLocationFilters);
    }
    if (SelectedAdvanceFilter === "Cross-platform Presence") {
      toggleFilter(
        value,
        selectedCrossPlatformFilters,
        setSelectedCrossPlatformFilters
      );
    }
  };

  useEffect(() => {
    if (SelectedAdvanceFilter === "Monetisation Platforms") {
      setMasterItemName("monetizationPlatformName");
      setSelectedFilterState(selectedMonetizationFilters);
      OpenAdvanceFilterOptionsModal(true);
    }
    if (SelectedAdvanceFilter === "Total Paid Audience") {
      setMasterItemName(null);
      setSelectedFilterState(selectedPaidAudienceFilters);
      OpenAdvanceFilterOptionsModal(true);
    }
    if (SelectedAdvanceFilter === "Collaborated With") {
      setMasterItemName(null);
      setSelectedFilterState(selectedCollaboratedWithFilters);
      OpenAdvanceFilterOptionsModal(true);
    }
    if (SelectedAdvanceFilter === "Campaign Goal") {
      setMasterItemName("CollabGoalsName");
      setSelectedFilterState(selectedCampaignGoalsFilters);
      OpenAdvanceFilterOptionsModal(true);
    }
    if (SelectedAdvanceFilter === "Location") {
      setMasterItemName(null);
      setSelectedFilterState(selectedLocationFilters);
      OpenAdvanceFilterOptionsModal(true);
    }
    if (SelectedAdvanceFilter === "Cross-platform Presence") {
      setMasterItemName("audiencePlatformName");
      setSelectedFilterState(selectedCrossPlatformFilters);
      OpenAdvanceFilterOptionsModal(true);
    }
  }, [
    selectedMonetizationFilters,
    SelectedAdvanceFilter,
    selectedPaidAudienceFilters,
    selectedCollaboratedWithFilters,
    selectedCampaignGoalsFilters,
    selectedLocationFilters,
    selectedCrossPlatformFilters,
  ]);

  return (
    <div className="w-screen h-screen flex items-end justify-end bg-[#121212c2] fixed top-0 left-0 z-50 font-inter">
      {AdvanceFilterOptionModal && (
        <div
          style={{ scrollbarWidth: "none" }}
          className="bg-[#EEE] p-[20px] gap-[20px] overflow-x-auto  flex flex-col w-[345px] h-screen "
        >
          <span className=" text-[16px] font-[500] text-[#424242] font-Inter ">
            Select one or more options
          </span>
          <div className="w-full text-[14px] font-[400]  flex flex-col gap-[8px]">
            {AdvanceFilters?.[SelectedAdvanceFilter]?.map((item, index) => {
              return (
                <div
                  key={index}
                  onClick={() =>
                    handleSelectfilter(masterItemName ? item?._id : item)
                  }
                  className="w-full flex justify-between items-center px-[12px] py-[8px] rounded-[4px] bg-[#fff] cursor-pointer "
                >
                  {masterItemName ? item?.[masterItemName] : item}{" "}
                  {selectedFilterState?.includes(
                    masterItemName ? item?._id : item
                  ) ? (
                    <MdOutlineCheckBox size={16} color="#FF5C5C" />
                  ) : (
                    <MdCheckBoxOutlineBlank size={16} />
                  )}
                </div>
              );
            })}
          </div>
        </div>
      )}
      <div className="bg-[#FFFFFF] flex flex-col items-center  w-[345px]  h-screen">
        <div className="w-full p-[20px]  flex flex-col gap-[8px]">
          <div className="w-full flex justify-between items-center">
            <div className="text-[20px] font-[600] text-[#424242] font-Inter  ">
              Advance Filters
            </div>
            <div
              onClick={() => OnClose()}
              className="w-[80px] flex justify-end cursor-pointer"
            >
              <IoIosClose color="black" size={24} />
            </div>
          </div>
          <span className=" w-full justify-start font-[400] text-[#757575] text-[12px]   ">
            Further fine-tune your influencer search
          </span>
        </div>
        <div className="w-full flex flex-col text-[14px] font-[500] text-[#424242]   ">
          {Object?.keys(AdvanceFilters)?.map((item, index) => {
            const selectedCount = {
              "Monetisation Platforms": selectedMonetizationFilters,
              "Total Paid Audience": selectedPaidAudienceFilters,
              "Collaborated With": selectedCollaboratedWithFilters,
              "Campaign Goal": selectedCampaignGoalsFilters,
              Location: selectedLocationFilters,
              "Cross-platform Presence": selectedCrossPlatformFilters,
            }[item]?.filter((filter) => {
              return AdvanceFilters[item]?.find((filterItem) => {
                return typeof filterItem === "object"
                  ? filterItem?._id === filter
                  : filterItem === filter;
              });
            }).length;
            return (
              <div
                key={index}
                onClick={() => {
                  OpenAdvanceFilterOptionsModal(false);
                  SetSelectedAdvanceFilter(item);
                }}
                className={`${
                  SelectedAdvanceFilter === item ? "bg-[#EEE]" : ""
                } w-full flex px-[12px] py-[16px] hover:bg-[#EEE] cursor-pointer`}
              >
                {item} ({selectedCount})
              </div>
            );
          })}
        </div>
        <div
          style={{ boxShadow: "0px -4px 8px 0px rgba(18, 18, 18, 0.10)" }}
          className="w-full mt-[auto] px-[20px] py-[12px] flex items-center justify-center bg-[#fff] "
        >
          <Button1
            text={"Apply"}
            onClick={() => OnClick()}
            icon={undefined}
            rightIcon={undefined}
            background={undefined}
            textColor={undefined}
            borderColor={undefined}
          />
        </div>
      </div>
    </div>
  );
};
